// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2eUCk","left":"StickyBox_left__1AZYF","right":"StickyBox_right__1Vo5O"};